import { render, staticRenderFns } from "./PaymentMethodsSetting.vue?vue&type=template&id=d2e997f2"
import script from "./PaymentMethodsSetting.vue?vue&type=script&lang=js"
export * from "./PaymentMethodsSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports